import cookies from 'js-cookie';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { compose } from 'redux';
import { Dispatch } from 'redux-api-middleware';
import { addAccount } from 'store/api/accounts/account/accountActions';
import { refreshToken as refreshTokenAction } from 'store/api/authorization/authorizationActions';
import { submitForm } from 'store/api/submitForm/submitForm';
import { AddAccountPayload, AddAccountResponse } from 'store/api/types';
import { AUTH_REFRESH_COOKIE } from 'store/store';

import { AddAccount } from './AddAccount';

const mapDispatchToProps = (dispatch: Dispatch, { history }: RouteComponentProps) => ({
  onAddAccount: submitForm<AddAccountResponse>(dispatch, (body: AddAccountPayload) => addAccount(body)),
  onAddSuccess: (account: string) => {
    dispatch<Promise<any>>(refreshTokenAction(cookies.get(AUTH_REFRESH_COOKIE) as string)).then(() => {
      history.push(`/${account}/account`);
    });
  },
});

export const AddAccountContainer = compose(
  connect(
    undefined,
    mapDispatchToProps,
  ),
)(AddAccount);
